(function ($) {
  'use strict';

  /* ===============================================================
     PWR HEADER
     =============================================================== */

  var PWR = window.PWR || {};
  var SCROLL_LOCK = PWR.scrollLock || null;


  /* ===============================================================
     HEADER
     =============================================================== */

  function Header(root) {

    this.root = root;
    this.$root = $(root);

    /*
     * IMPORTANT:
     * Drawer and overlay are OUTSIDE the main header wrapper.
     * Therefore they must NOT be searched only inside this.$root.
     */

    this.$drawer =
      $('[data-pwr-header-drawer]').first();

    this.$drawerToggle =
      this.$root.find('[data-pwr-drawer-toggle]');

    this.$drawerClose =
      this.$drawer.find('[data-pwr-drawer-close]');

    this.$overlay =
      $('[data-pwr-header-overlay]').first();

    this.$searchToggle =
      this.$root.find('[data-pwr-search-toggle]');

    this.$searchPanel =
      this.$root.find('[data-pwr-search-panel]');

    this.$searchClose =
      this.$searchPanel.find(
        '[data-pwr-search-close], .search-modal__close-button, .pwr-search-close'
      );

    this.init();
  }


  /* ===============================================================
     INIT
     =============================================================== */

  Header.prototype.init = function () {

    this._bindDrawer();
    this._bindMegaMenu();
    this._bindSearch();
    this._bindKeyboard();
    this._bindStickyFallback();


    console.log('PWR Header initialized', {
      drawer: this.$drawer.length,
      drawerToggle: this.$drawerToggle.length,
      drawerClose: this.$drawerClose.length,
      overlay: this.$overlay.length,
      search: this.$searchPanel.length
    });
  };


  /* ===============================================================
     DRAWER
     =============================================================== */

  Header.prototype._bindDrawer = function () {

    var self = this;


    /* ---------------------------------------------------------------
       BURGER BUTTON
       --------------------------------------------------------------- */

    this.$drawerToggle
      .off('click.pwrHeader')
      .on(
        'click.pwrHeader',
        function (event) {

          event.preventDefault();
          event.stopPropagation();

          if (!self.$drawer.length) {
            console.error(
              'PWR Header: drawer not found'
            );
            return;
          }

          if (
            self.$drawer.hasClass('is-open')
          ) {

            self.closeDrawer();

          } else {

            self.openDrawer();

          }
        }
      );


    /* ---------------------------------------------------------------
       CLOSE BUTTON
       --------------------------------------------------------------- */

    this.$drawerClose
      .off('click.pwrHeader')
      .on(
        'click.pwrHeader',
        function (event) {

          event.preventDefault();

          self.closeDrawer();

        }
      );


    /* ---------------------------------------------------------------
       OVERLAY
       --------------------------------------------------------------- */

    this.$overlay
      .off('click.pwrHeader')
      .on(
        'click.pwrHeader',
        function (event) {

          event.preventDefault();

          self.closeDrawer();
          self.closeSearch();

        }
      );


    /* ---------------------------------------------------------------
       MOBILE SUBMENUS
       --------------------------------------------------------------- */

    this.$drawer
      .find('[data-pwr-submenu-toggle]')
      .off('click.pwrHeader')
      .on(
        'click.pwrHeader',
        function (event) {

          event.preventDefault();

          var $button = $(this);

          var expanded =
            $button.attr('aria-expanded') === 'true';

          var submenuId =
            $button.attr('aria-controls');

          if (!submenuId) {
            return;
          }

          var $panel =
            $('#' + submenuId);

          if (!$panel.length) {
            return;
          }


          $button.attr(
            'aria-expanded',
            expanded ? 'false' : 'true'
          );


          if (expanded) {

            $panel
              .stop(true, true)
              .slideUp(
                220,
                function () {

                  $panel.attr(
                    'hidden',
                    true
                  );

                }
              );

          } else {

            $panel
              .removeAttr('hidden')
              .hide()
              .stop(true, true)
              .slideDown(220);

          }
        }
      );
  };


  /* ===============================================================
     OPEN DRAWER
     =============================================================== */

  Header.prototype.openDrawer = function () {

    if (!this.$drawer.length) {

      console.error(
        'PWR Header: drawer not found'
      );

      return;
    }


    /*
     * Close search first
     */

    this.closeSearch();


    /*
     * Open drawer
     */

    this.$drawer
      .removeAttr('inert')
      .addClass('is-open');


    /*
     * Burger state
     */

    this.$drawerToggle.attr(
      'aria-expanded',
      'true'
    );


    /*
     * Overlay
     */

    this.$overlay
      .addClass('is-visible')
      .attr(
        'aria-hidden',
        'false'
      );


    /*
     * Lock page
     */

    if (
      SCROLL_LOCK &&
      typeof SCROLL_LOCK.lock === 'function'
    ) {

      SCROLL_LOCK.lock();

    } else {

      document.documentElement.classList.add(
        'pwr-menu-open'
      );

      document.body.classList.add(
        'pwr-menu-open'
      );
    }
  };


  /* ===============================================================
     CLOSE DRAWER
     =============================================================== */

  Header.prototype.closeDrawer = function () {

    if (!this.$drawer.length) {
      return;
    }


    /*
     * Close drawer
     */

    this.$drawer
      .removeClass('is-open')
      .attr(
        'inert',
        ''
      );


    /*
     * Burger state
     */

    this.$drawerToggle.attr(
      'aria-expanded',
      'false'
    );


    /*
     * Close overlay if search is closed
     */

    if (!this._searchOpen()) {

      this.$overlay
        .removeClass('is-visible')
        .attr(
          'aria-hidden',
          'true'
        );
    }


    /*
     * Unlock page
     */

    if (
      SCROLL_LOCK &&
      typeof SCROLL_LOCK.unlock === 'function'
    ) {

      SCROLL_LOCK.unlock();

    } else {

      document.documentElement.classList.remove(
        'pwr-menu-open'
      );

      document.body.classList.remove(
        'pwr-menu-open'
      );
    }
  };


  /* ===============================================================
     SEARCH
     =============================================================== */

  Header.prototype._bindSearch = function () {

    var self = this;


    /*
     * Search button
     */

    this.$searchToggle
      .off('click.pwrHeader')
      .on(
        'click.pwrHeader',
        function (event) {

          event.preventDefault();
          event.stopPropagation();

          if (
            self._searchOpen()
          ) {

            self.closeSearch();

          } else {

            self.openSearch();

          }
        }
      );


    /*
     * Search close
     */

    this.$searchClose
      .off('click.pwrHeader')
      .on(
        'click.pwrHeader',
        function (event) {

          event.preventDefault();

          self.closeSearch();

        }
      );
  };


  /* ===============================================================
     SEARCH OPEN CHECK
     =============================================================== */

  Header.prototype._searchOpen = function () {

    return (
      this.$searchPanel.length &&
      this.$searchPanel.hasClass('is-open')
    );
  };


  /* ===============================================================
     OPEN SEARCH
     =============================================================== */

  Header.prototype.openSearch = function () {

    if (!this.$searchPanel.length) {
      return;
    }


    /*
     * Close mobile menu
     */

    this.closeDrawer();


    /*
     * Open search panel
     */

    this.$searchPanel
      .removeAttr('inert')
      .addClass('is-open');


    /*
     * Open Dawn search details
     */

    var $details =
      this.$searchPanel
        .find('details-modal > details')
        .first();


    if ($details.length) {

      $details.prop(
        'open',
        true
      );
    }


    /*
     * Overlay
     */

    this.$overlay
      .addClass('is-visible')
      .attr(
        'aria-hidden',
        'false'
      );


    /*
     * Accessibility
     */

    this.$searchToggle.attr(
      'aria-expanded',
      'true'
    );


    /*
     * Focus search input
     */

    var $input =
      this.$searchPanel
        .find('input[type="search"]')
        .first();


    if ($input.length) {

      window.requestAnimationFrame(
        function () {

          $input.trigger('focus');

        }
      );
    }
  };


  /* ===============================================================
     CLOSE SEARCH
     =============================================================== */

  Header.prototype.closeSearch = function () {

    if (!this.$searchPanel.length) {
      return;
    }


    /*
     * Close Dawn details
     */

    var $details =
      this.$searchPanel
        .find('details-modal > details')
        .first();


    if ($details.length) {

      $details.prop(
        'open',
        false
      );
    }


    /*
     * Close PWR search
     */

    this.$searchPanel
      .removeClass('is-open')
      .attr(
        'inert',
        ''
      );


    /*
     * Accessibility
     */

    this.$searchToggle.attr(
      'aria-expanded',
      'false'
    );


    /*
     * Hide overlay if drawer closed
     */

    if (
      !this.$drawer.hasClass('is-open')
    ) {

      this.$overlay
        .removeClass('is-visible')
        .attr(
          'aria-hidden',
          'true'
        );
    }
  };


  /* ===============================================================
     MEGA MENU
     =============================================================== */

  Header.prototype._bindMegaMenu = function () {

    var self = this;

    var supportsHover =
      window.matchMedia &&
      window.matchMedia(
        '(hover: hover) and (pointer: fine)'
      ).matches;


    if (!supportsHover) {
      return;
    }


    this.$root
      .find('[data-pwr-mega]')
      .each(function () {

        var $details = $(this);

        var closeTimer;


        $details.on(
          'mouseenter.pwrHeader',
          function () {

            clearTimeout(closeTimer);


            self.$root
              .find('[data-pwr-mega]')
              .not($details)
              .prop(
                'open',
                false
              );


            $details.prop(
              'open',
              true
            );
          }
        );


        $details.on(
          'mouseleave.pwrHeader',
          function () {

            closeTimer =
              setTimeout(
                function () {

                  $details.prop(
                    'open',
                    false
                  );

                },
                150
              );
          }
        );

      });
  };


  /* ===============================================================
     KEYBOARD
     =============================================================== */

  Header.prototype._bindKeyboard = function () {

    var self = this;


    $(document)
      .off('keydown.pwrHeader')
      .on(
        'keydown.pwrHeader',
        function (event) {

          if (
            event.key !== 'Escape'
          ) {
            return;
          }


          if (
            self._searchOpen()
          ) {

            self.closeSearch();

            return;
          }


          if (
            self.$drawer.hasClass(
              'is-open'
            )
          ) {

            self.closeDrawer();

            return;
          }


          self.$root
            .find('[data-pwr-mega]')
            .prop(
              'open',
              false
            );

        }
      );
  };


  /* ===============================================================
     STICKY FALLBACK
     =============================================================== */

  Header.prototype._bindStickyFallback = function () {

    var $header =
      this.$root.find(
        '[data-section-type="pwr-header"]'
      );


    if (!$header.length) {
      return;
    }


    /*
     * PWR Core handles sticky
     */

    if (
      window.PWR &&
      window.PWR.registerSection
    ) {

      return;
    }


    var lastScroll =
      window.scrollY;


    $(window)
      .off('scroll.pwrHeaderFallback')
      .on(
        'scroll.pwrHeaderFallback',
        function () {

          var currentScroll =
            window.scrollY;


          if (
            currentScroll > 80
          ) {

            $header.addClass(
              'is-condensed'
            );

          } else {

            $header.removeClass(
              'is-condensed'
            );
          }


          if (
            currentScroll > lastScroll &&
            currentScroll > 180
          ) {

            $header.addClass(
              'is-hidden'
            );

          } else {

            $header.removeClass(
              'is-hidden'
            );
          }


          lastScroll =
            currentScroll;

        }
      );
  };


  /* ===============================================================
     INITIALIZE
     =============================================================== */

  function initPWRHeader() {

    $('[data-section-type="pwr-header"]')
      .each(function () {

        if (
          this.__pwrHeaderInitialized
        ) {
          return;
        }


        this.__pwrHeaderInitialized =
          true;


        /*
         * Header itself is used as root.
         *
         * Drawer is searched globally because
         * drawer is outside the header element.
         */

        new Header(this);

      });
  }


  /* ===============================================================
     START
     =============================================================== */

  $(function () {

    initPWRHeader();

  });


})(jQuery);